// requires
import _ from 'lodash'
import md5 from 'md5'

// utils
export function cleanCrossRef(data) {
  // function for parsing CrossRef results
  const rawData = data['message']['items']
  const articles = rawData.map(buildCrossRefArticle)
  return articles
}

function buildCrossRefArticle(rawCrossRefEntry) {
  const { title, publisher, volume, issue, page, doi, url, author } =
    rawCrossRefEntry
  const refType = 'article'
  const articleTitle = title[0] || ''
  const articleAuthors = _.join(
    _.map(author, (author) => {
      return `${author.family} ${author.given}`
    })
  )
  const uniqHash = md5(refType + articleTitle + articleAuthors)
  // map raw CrossRef results to preferred article object
  return {
    ref_type: refType,
    title: articleTitle,
    year: rawCrossRefEntry.created['date-time'],
    publisher: publisher,
    volume: volume,
    number: issue,
    pages: page,
    authors: articleAuthors,
    doi: doi,
    url: url,
    uniq_hash: uniqHash,
  }
}

export function cleanGoogleBooks(data) {
  // function for parsing Google Books results
  const rawData = data['items'] || []
  const rawDataIsbn13 = rawData.filter(filterHasIsbn13)
  const books = rawDataIsbn13.map(buildGoogleBook)
  return books
}

function buildGoogleBook(rawGoogleBook) {
  const volume_info = rawGoogleBook['volumeInfo']
  const refType = 'book'
  const bookTitle = volume_info.title
  const bookAuthors = _.join(
    _.map(volume_info.authors, (author) => {
      return author
    }),
    ', '
  )
  const uniqHash = md5(refType + bookTitle + bookAuthors)

  return {
    ref_type: refType,
    title: bookTitle,
    year: volume_info['publishedDate'],
    publisher: volume_info.publisher || '',
    authors: bookAuthors,
    isbn: getIsbn13(volume_info['industryIdentifiers']),
    url: volume_info.canonicalVolumeLink,
    uniq_hash: uniqHash,
  }
}

function getIsbn13(rawGoogleBookIds) {
  const id_isbn_13 = rawGoogleBookIds.filter(function (bookid) {
    return bookid['type'] === 'ISBN_13'
  })[0]
  return id_isbn_13['identifier']
}

function filterHasIsbn13(rawGoogleBook) {
  //filter Google Book entries that have ISBN13
  const bookinfo = rawGoogleBook['volumeInfo']

  if (!bookinfo.industryIdentifiers) {
    return false
  }
  const ids = bookinfo.industryIdentifiers
  const isbn_13_provided = ids.some(function (element, index, array) {
    return element['type'] === 'ISBN_13'
  })
  return isbn_13_provided
}

export function getGoogleBooksUrl(query, userLang = 'en') {
  const googleKey = '&key=AIzaSyCNPO2rSvwaJ3isSilx1jbHB0FZBnu1bQQ'
  const googleBooksUrl =
    'https://www.googleapis.com/' +
    `books/v1/volumes?q=${query}` +
    `&langRestrict=${userLang}` +
    googleKey
  return googleBooksUrl
}

export function getCrossRefUrl(query) {
  const crossRefUrl =
    'http://api.crossref.org' +
    `/works?query=${query}` +
    '&filter=type:journal-article&rows=150'
  return crossRefUrl
}
